console.log("custom cart and checkout");

document.addEventListener("DOMContentLoaded", function () {
  // Function to check cart total
  function checkCartTotal() {
    console.log('checkCartTotal');
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        let cartTotal = cart.total_price; // Shopify returns the total price in cents
        console.log(cartTotal);

        // Convert the total to pounds
        cartTotal = cartTotal / 100;

        updateCartUI(cartTotal);
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
      });
  }

  // Event handler for plus button clicks
  function handlePlusButtonClick(event) {
    event.preventDefault(); // Prevent the default action of the button
    console.log('Plus button clicked');
    checkCartTotal();
setTimeout(checkCartTotal, 1000); // 1000 milliseconds = 1 second
  }

  // Event handler for minus button clicks
  function handleMinusButtonClick(event) {
    event.preventDefault(); // Prevent the default action of the button
    console.log('Minus button clicked');
    checkCartTotal();
setTimeout(checkCartTotal, 1000); // 1000 milliseconds = 1 second
  }

  // Function to update the UI based on cart total
  function updateCartUI(cartTotal) {
    const cartFullDiv = document.querySelector(".cart-full");
    const submitButton = document.querySelector(".cart__checkout-button");
    const plusButtons = document.querySelectorAll(".quantity__button[name='plus']");
    const minusButtons = document.querySelectorAll(".quantity__button[name='minus']");

    if (cartTotal > 8000) {
      console.log("Cart total exceeds £8000");
      if (cartFullDiv) cartFullDiv.style.display = "block";
      if (submitButton) submitButton.style.display = "none";
      plusButtons.forEach(button => {
        button.disabled = true;
        button.classList.add("disabled");
      });
    } else {
      if (cartFullDiv) cartFullDiv.style.display = "none";
      if (submitButton) submitButton.style.display = "block";
      plusButtons.forEach(button => {
        button.disabled = false;
        button.classList.remove("disabled");
      });
    }
  }

  // Function to initialize event listeners
  function initializeEventListeners() {
    const plusButtons = document.querySelectorAll(".quantity__button[name='plus']");
    const minusButtons = document.querySelectorAll(".quantity__button[name='minus']");
    const removeButtons = document.querySelectorAll('cart-remove-button');

    if (plusButtons.length === 0) {
      console.log('No plus buttons found on the page');
    } else {
      console.log('Plus buttons found on the page');
      plusButtons.forEach(button => {
        button.removeEventListener("click", handlePlusButtonClick); // Remove any existing listeners
        button.addEventListener("click", handlePlusButtonClick);
      });
    }

    if (minusButtons.length === 0) {
      console.log('No minus buttons found on the page');
    } else {
      console.log('Minus buttons found on the page');
      minusButtons.forEach(button => {
        button.removeEventListener("click", handleMinusButtonClick); // Remove any existing listeners
        button.addEventListener("click", handleMinusButtonClick);
      });
    }

    if (removeButtons.length === 0) {
      console.log('No remove buttons found on the page');
    } else {
      console.log('Remove buttons found on the page');
      removeButtons.forEach(button => {
        button.removeEventListener("click", handleMinusButtonClick); // Remove any existing listeners
        button.addEventListener("click", handleMinusButtonClick);
      });
    }
  }

  // Initial check on page load
  checkCartTotal();
  
  setInterval(checkCartTotal, 5000); // Adjust the interval as needed

  // Observe the document for changes and initialize event listeners when elements are added
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        console.log('DOM mutation detected, re-initializing event listeners');
        initializeEventListeners();
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Initial call to initialize event listeners
  initializeEventListeners();
});
